import * as React from 'react';
import { TableChorinitia } from '../../genericComponents/TableChorinitia/TableChorinitia';
import * as ReqType from '../../../types/ServerRequests';
import { SubscriptionLine } from './SubscriptionLine';
import { SubscriptionsService } from '../../../services/SubscriptionService';
import { FieldSort, FiltreSubState } from './SubscriptionFilter';

export interface Props {
    subFieldSort: FieldSort;
    subTypeFilter: FiltreSubState;
}

interface State {
    inscriptions: ReqType.Subscription[];
}

/**
 * ce composant permet d'afficher la liste des subscriptions
 */
export class ListSubscription extends React.Component {
    props: Props;
    state: State;

    constructor(props: Props) {
        super(props);
        this.state = {
            inscriptions: [],
        };
        this.getSubscriptions();
    }

    render() {
        const filteredList = this.filterList(this.state.inscriptions);
        const sortedList = this.orderList(filteredList);
        const listItems: JSX.Element[] = sortedList.map(
            (inscription: ReqType.Subscription) => {
                return (
                    <SubscriptionLine
                        inscription={inscription}
                        key={inscription.id}
                        validateInscription={
                            (e: ReqType.Subscription) => {
                                e.etat = ReqType.SubscriptionState.TERMINEE;
                                this.setState({ inscriptions: this.state.inscriptions });
                            }
                        }
                    />
                );
            }
        );

        return (
            <div>
                <TableChorinitia
                    header={
                        <thead className="thead-light">
                            <tr>
                                <th scope="col">Pseudo</th>
                                <th scope="col">Etat</th>
                                <th scope="col">Consulter</th>
                                <th scope="col">Valider</th>
                            </tr>
                        </thead>
                    }
                >
                    <tbody>
                        {listItems}
                    </tbody>
                </TableChorinitia>
            </div>
        );
    }

    private getSubscriptions() {
        SubscriptionsService.getInstance().getSubscriptions().then(
            (subs: ReqType.Subscription[]) => {
                this.setState({ inscriptions: subs });
            }
        );
    }

    private filterList(list: ReqType.Subscription[]) {
        if (this.props.subTypeFilter === FiltreSubState.TOUS) {
            return list.filter(
                (sub: ReqType.Subscription) => { return true; }
            );
        } else if (this.props.subTypeFilter === FiltreSubState.A_VALIDER) {
            return list.filter(
                (sub: ReqType.Subscription) => { return sub.etat === ReqType.SubscriptionState.A_VALIDER; }
            );
        } else if (this.props.subTypeFilter === FiltreSubState.EN_COURS) {
            return list.filter(
                (sub: ReqType.Subscription) => { return sub.etat === ReqType.SubscriptionState.EN_COURS; }
            );
        } else if (this.props.subTypeFilter === FiltreSubState.VALIDEE) {
            return list.filter(
                (sub: ReqType.Subscription) => { return sub.etat === ReqType.SubscriptionState.TERMINEE; }
            );
        } else {
            return list;
        }
    }

    private orderList(list: ReqType.Subscription[]) {
        if (this.props.subFieldSort === FieldSort.PSEUDO_ASC) {
            return list.sort(
                (a: ReqType.Subscription, b: ReqType.Subscription) => {
                    return a.user.username.localeCompare(b.user.username);
                }
            );
        } else if (this.props.subFieldSort === FieldSort.PSEUDO_DEC) {
            return list.sort(
                (a: ReqType.Subscription, b: ReqType.Subscription) => {
                    return b.user.username.localeCompare(a.user.username);
                }
            );
        } else {
            return list;
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/SubscriptionManagmentPage/internalComponents/ListSubscription.tsx